import * as types from "../action-types";

const initialState = {
    loading: false,
    paginated_companies: {
        total: 0,
        per_page: 0,
        offset: 0,
        to: 0,
        last_page: 0,
        current_page: 0,
        from: 0,
        data: [],
    },
    upload_errors: [],
};

// eslint-disable-next-line import/no-anonymous-default-export
export default (state = initialState, { type, payload }) => {
    switch (type) {
        case types.GET_TABLE_COMPANIES.REQUEST:
            return {
                ...state,
                loading: true,
            };
        case types.GET_TABLE_COMPANIES.SUCCESS:
            return {
                ...state,
                loading: false,
                paginated_companies: payload
            };
        case types.GET_TABLE_COMPANIES.FAILURE:
            return {
                ...state,
                loading: false,
            };
        case types.UPLOAD_COMPANIES.REQUEST:
            return {
                ...state,
                upload_errors: [],
            };
        case types.UPLOAD_COMPANIES.SUCCESS:
            return {
                ...state,
                upload_errors: payload.errors || [],
            };
        default:
            return state;
    }
};
